import React, { useEffect, useState } from "react";

import NoDataFound from "../common/NoDataFound";
import NextImage from "../common/NextImage";
import { loadStyles } from "../../utils/cssLoader";
import { useCricketLiveSocket } from "../../hooks/useCricketLiveSocket";

const LiveScoreCard = ({
  ServerData,
  loadCSS = true,
  dataClient = false,
  title,
  socketUrl,
  matchId
}) => {
  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";
  const [clientData, setClientData] = useState(null);
  const matchData = dataClient ? clientData : ServerData;
  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketmatch");
    }
  }, [loadCSS]);
  const liveData = useCricketLiveSocket(socketUrl, matchId);
  const data = liveData ?? matchData;

  const hasData =
    data && (data?.active_bats?.length > 0 || data?.active_bowls?.length > 0);
  return (
    <>
      {title ? <h1>{title}</h1> : null}

      {hasData ? (
        <>
          <div className="global_table cr_macth_scorecard live_sts">
            <table>
              <thead>
                <tr>
                  <th>
                    <strong>Batsman</strong>
                  </th>
                  <th>
                    <strong>R</strong>
                  </th>
                  <th>
                    <strong>B</strong>
                  </th>
                  <th>
                    <strong>4s</strong>
                  </th>
                  <th>
                    <strong>6s</strong>
                  </th>
                  <th>
                    <strong>SR</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.active_bats?.map((player, i) => (
                  <tr
                    key={i}
                    className={`${player?.ty === "Not Out" || player?.actv === 1
                      ? "not_out"
                      : ""
                      }`}
                  >
                    <td>
                      <div className="bastman_td">
                        <span className="name">
                          {player?.player?.name}{" "}
                          {player?.is_wick_k ? " (WK)" : null}
                          {player?.is_cap ? " (C)" : null}
                          {player?.actv === 1 ? (
                            <span className="bat_ico">
                              <NextImage
                                src={`${baseURL}/public/assets/images/Bat1.png`}
                                width={15}
                                height={14}
                                alt="bat"
                              />
                            </span>
                          ) : null}
                        </span>
                        <span className="bow_inf">
                          {player?.fielder &&
                            ` ${player?.ty === "Catch OUT " ? "c " : "o "} ${player?.fielder?.nm
                            } `}
                          {player?.ty}
                          {player?.bowler && ` b ${player?.bowler?.nm}`}
                        </span>
                      </div>
                    </td>
                    <td>
                      <strong>{player?.sc}</strong>
                    </td>
                    <td>{player?.bls}</td>
                    <td>{player?.fr}</td>
                    <td>{player?.sx}</td>
                    <td>{Number(player?.rr).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="global_table cr_macth_scorecard live_sts">
            <table>
              <thead>
                <tr>
                  <th>
                    <strong>Bowlers</strong>
                  </th>
                  <th>
                    <strong>O</strong>
                  </th>
                  <th>
                    <strong>M</strong>
                  </th>
                  <th>
                    <strong>R</strong>
                  </th>
                  <th>
                    <strong>WD</strong>
                  </th>
                  <th>
                    <strong>ER</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.active_bowls?.map((player, i) => (
                  <tr
                    key={i}
                    className={`${player?.actv === 1 ? "not_out" : ""}`}
                  >
                    <td>
                      <span className="name">
                        {player?.player?.name}
                        {player?.actv === 1 ? (
                          <span className="bat_ico">
                            <NextImage
                              src={`${baseURL}/public/assets/images/cricket_Ball.png`}
                              width={14}
                              height={14}
                              alt="bat"
                            />
                          </span>
                        ) : null}
                      </span>
                    </td>
                    <td>{player?.ovs}</td>
                    <td>{player?.mdns}</td>
                    <td>{player?.sc}</td>
                    <td>{player?.wckts}</td>
                    <td>{Number(player?.rr).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {data?.last_wicket ?
            <ul className="live_inf_sts">
              <li>
                L’bat: <span>{`${data?.last_wicket?.batsman?.name} `}</span>
              </li>
              <li>
                FoW:{" "}
                <span>{`${data?.last_wicket?.sc} / ${data?.last_wicket?.num} (${data?.last_wicket?.bla} Ov) `}</span>
              </li>
            </ul> : null}
        </>
      ) : (
        <NoDataFound />
      )}
    </>
  );
};

export default LiveScoreCard;
